import { post, request } from '../api';

/** Mirrors the views of `apps/api/src/inbox/*` (ADR-0008). */

export const INBOX_SOURCES = ['photos', 'telegram', 'youtube', 'zoom', 'mail', 'browser_tab', 'dialog', 'notebook', 'manual'] as const;
export type InboxSource = (typeof INBOX_SOURCES)[number];
export type InboxStatus = 'new' | 'needs_human' | 'done' | 'trash';
export type InboxOutcome = 'task' | 'finding' | 'funnel_case' | 'knowledge_source' | 'reference' | 'nothing';

export interface InboxRow {
  id: string;
  source: InboxSource;
  externalId: string;
  title: string | null;
  url: string | null;
  status: InboxStatus;
  outcome: InboxOutcome | null;
  outcomeRef: string | null;
  triageNote: string | null;
  business: { id: string; name: string } | null;
  file: { id: string; filename: string; mimeType: string; sizeBytes: number; path: string } | null;
  capturedAt: string;
  triagedAt: string | null;
  sourceClearedAt: string | null;
  taskCount: number;
}

export interface InboxDetail extends InboxRow {
  text: string | null;
  metadata: Record<string, unknown>;
  triagedBy: { id: string; displayName: string } | null;
  panelUrl: string;
  tasks: Array<{ id: string; key: string; title: string; status: string }>;
}

export interface InboxListResult {
  rows: InboxRow[];
  total: number;
  page: number;
  pageSize: number;
  counts: Record<InboxStatus, number> & { sortedToday: number };
}

export interface InboxListParams {
  status?: InboxStatus[];
  source?: InboxSource;
  businessId?: string;
  page: number;
  pageSize: number;
}

export const inboxApi = {
  list(p: InboxListParams): Promise<InboxListResult> {
    const q = new URLSearchParams({ page: String(p.page), pageSize: String(p.pageSize) });
    if (p.status?.length) q.set('status', p.status.join(','));
    if (p.source) q.set('source', p.source);
    if (p.businessId) q.set('businessId', p.businessId);
    return request(`/inbox?${q}`);
  },
  get: (id: string): Promise<InboxDetail> => request(`/inbox/${encodeURIComponent(id)}`),
  triage: (id: string, body: { status: 'done' | 'trash'; outcome?: InboxOutcome; note?: string }) => post<{ item: InboxDetail }>(`/inbox/${encodeURIComponent(id)}/triage`, body),
  answer: (id: string, text: string) => post<InboxDetail>(`/inbox/${encodeURIComponent(id)}/answer`, { text }),
};
